import KanaMatch from './KanaMatch';

export default KanaMatch;
